@layer reset, default, type;

@layer reset {
  :host {
    display: block;

    .gcds-notice {
      text-align: left;
      box-sizing: border-box;

      slot {
        display: initial;
      }
    }
  }
}

@layer default {
  :host .gcds-notice {
    color: var(--gcds-notice-text);
    display: grid;
    grid-template-columns: var(--gcds-notice-icon-width) auto;
    gap: var(--gcds-notice-icon-gap);

    .notice__heading {
      --gcds-heading-h2-desktop: var(
        --gcds-notice-content-heading-font-desktop
      );
      --gcds-heading-h2-mobile: var(--gcds-notice-content-heading-font-mobile);
      --gcds-heading-h4-desktop: var(
        --gcds-notice-content-heading-font-desktop
      );
      --gcds-heading-h4-mobile: var(--gcds-notice-content-heading-font-mobile);
      --gcds-heading-h5-desktop: var(
        --gcds-notice-content-heading-font-desktop
      );
      --gcds-heading-h5-mobile: var(--gcds-notice-content-heading-font-mobile);
      margin-block-start: var(--gcds-notice-content-heading-margin-block-start-desktop);

      @media only screen and (width < 48em) {
        margin-block-start: var(--gcds-notice-content-heading-margin-block-start-mobile);
      }
    }

    .notice__icon {
      margin: var(--gcds-notice-icon-margin);

      &:before {
        display: block;
        width: var(--gcds-notice-border-width);
        margin: 0 auto;
        height: var(--gcds-notice-icon-before-height);
        content: '';
        background-color: currentColor;
      }

      &:after {
        display: block;
        width: var(--gcds-notice-border-width);
        margin: 0 auto;
        height: var(--gcds-notice-icon-after-height);
        content: '';
        background-color: currentColor;
      }
    }

    ::slotted(*) {
      margin-block-start: 0;
      font: var(--gcds-notice-content-slotted-font-desktop);

      @media only screen and (width < 48em) {
        font: var(--gcds-notice-content-slotted-font-mobile);
      }
    }

    ::slotted(*:last-child) {
      margin-block-end: 0;
    }

    ::slotted(*:not(:last-child)) {
      margin-block-end: var(--gcds-notice-content-slotted-margin);
    }

    ::slotted(ol),
    ::slotted(ul) {
      margin-inline-start: var(--gcds-notice-content-slotted-list-margin);
      padding: 0;
    }
  }
}

@layer type {
  :host .gcds-notice {
    &.notice--type-danger .notice__icon {
      color: var(--gcds-notice-danger-text);
    }

    &.notice--type-info .notice__icon {
      color: var(--gcds-notice-info-text);
    }

    &.notice--type-success .notice__icon {
      color: var(--gcds-notice-success-text);
    }

    &.notice--type-warning .notice__icon {
      color: var(--gcds-notice-warning-text);
    }
  }
}
